import axios from "axios";
import { KEY_ACCESS_TOKEN, KEY_COURSE, KEY_LOGIN_ACCESS_TOKEN } from "./constants";

let appConfig;
export let axiosInstance;

export const getAxiosInstance = async (data) => {
  appConfig = data[0]?.config;
  if (axiosInstance) {
    return axiosInstance;
  }
  axiosInstance = axios.create({
    baseURL: `${appConfig.apiBaseUrl}`,
    // baseURL: `http://localhost:4000/api`,
    timeout: 25000,
  });

  axiosInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers["access-token"] = localStorage.getItem(KEY_LOGIN_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  });

  //Response interceptor for API calls
  axiosInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error) {
      console.log("ApiService: Interceptor: ", error);
      if (!error.response?.config && error.response?.status !== 401) {
        return error;
      }

      if (error.response?.status === 400 || error.response?.status === 404 || error.response?.status === 500) {
        return error;
      }
      sessionStorage.clear();
      window.location.reload();
    },
  );
};

export const getConfig = async () => {
  // const path = "flame-portal-uat.ken42.com";
  // const res = await axios.get(`${configUrl}/${path}`);
  // return res && res.data ? res.data : null;
  const data = [{
    "config": {
      "integrationUrl": 'https://ken-api-prod.thekenverse.com/flame-myres-node-prod/api/',
      "apiBaseUrl": 'https://ken-api-prod.thekenverse.com/flame-myres-node-prod/api/',
    }
  }];

  return data;
};

export const getCurrentStage = async (contact, windowId) => {
  const path = `/sf/residence/getCurrentStage/${contact}/${windowId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getApplications = async (contact, windowId) => {
  const path = `/sf/residence/getRoomDetails/${contact}/${windowId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getResidenceHistory = async (contact, windowId) => {
  const path = `/sf/residence/getResidentHistory/${contact}/${windowId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getProvisionalAllotmentDetails = async (contact, windowId) => {
  const path = `/sf/residence/getProvisionalAllotmentDetails/${contact}/${windowId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postRoomRequest = async (payload) => {
  const path = `/sf/residence/postRoomRequest`;
  const res = await axiosInstance.post(`${path}`, payload);
  return res && res.data ? res.data : null;
};

export const getAllRoomDetails = async (contact) => {
  const path = `/sf/residence/getAllRoomDetails/${contact}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getEligibilityDetails = async (contact) => {
  const path = `/sf/residence/getEligibilityDetails/${contact}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const requestForOTP = async (payload) => {
  const path = `/sf/residence/getotp?contactId=${payload}`;
  const res = await axiosInstance.post(`${path}`);
  return res && res.data ? res.data : null;
};

export const verifyOTP = async (payload) => {
  const path = `/sf/residence/verifyotp?contactId=${payload.id}&otp=${payload.otp}`;
  const res = await axiosInstance.get(`${path}`);
  var cour = res.data.userCourse;
  localStorage.setItem(KEY_COURSE, JSON.stringify(cour));
  return res && res.data ? res.data : null;
};

export const hdfcPaymentIntegartion = async (data) => {
  const path = "/hdfc/payments/initiate";
  const res = axiosInstance.post(path, data);
  return res;
};

export const getFeeReceipt = async (transactionId) => {
  const path = `/sf/transaction/receipt?transactionId=${transactionId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getCurrentBatch = async (contactId) => {
  const path = `/sf/get_batch_info?contactId=${contactId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getDocumentUrl = async (documentId) => {
  const path = `/sf/get/residence/contentVersion/${documentId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};
